import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export const dict = {
  nav: {
    home: { es: "Inicio", en: "Home" },
    tours: { es: "Tours", en: "Tours" },
    experiences: { es: "Experiencias", en: "Experiences" },
    about: { es: "Nosotros", en: "About" },
    faq: { es: "Preguntas", en: "FAQ" },
    contact: { es: "Contacto", en: "Contact" },
    book: { es: "Reservar ahora", en: "Book now" },
  },
  hero: {
    kicker: { es: "Agencia boutique de experiencias", en: "Boutique experience agency" },
    title_a: { es: "Descubre Teotihuacán.", en: "Discover Teotihuacán." },
    title_b: { es: "Vive México.", en: "Live Mexico." },
    sub: {
      es: "Experiencias boutique, tours y aventuras cuidadosamente diseñadas para descubrir México de una manera diferente.",
      en: "Boutique experiences, tours and adventures carefully designed to discover Mexico in a different way.",
    },
    cta_primary: { es: "Explorar experiencias", en: "Explore experiences" },
    cta_secondary: { es: "Reservar ahora", en: "Book now" },
    trustline: { es: "Teotihuacán · Ciudad de México · Experiencias privadas", en: "Teotihuacán · Mexico City · Private experiences" },
    scroll: { es: "Descubre", en: "Discover" },
  },
  quickbook: {
    title: { es: "¿Qué experiencia estás buscando?", en: "What experience are you looking for?" },
    destination: { es: "Destino", en: "Destination" },
    any: { es: "Todos los destinos", en: "All destinations" },
    date: { es: "Fecha", en: "Date" },
    people: { es: "Personas", en: "Guests" },
    cta: { es: "Buscar experiencias", en: "Search experiences" },
  },
  prefooter: {
    title: { es: "Tu próxima experiencia comienza aquí.", en: "Your next experience starts here." },
    body: { es: "Elige cómo quieres descubrir México.", en: "Choose how you want to discover Mexico." },
    cta_tours: { es: "Explorar tours", en: "Explore tours" },
    cta_expert: { es: "Hablar con un experto", en: "Talk to an expert" },
  },
  trust: {
    kicker: { es: "Por qué Huitzil-Coatl", en: "Why Huitzil-Coatl" },
    title: { es: "Un México cuidado hasta el último detalle.", en: "A Mexico cared for down to the last detail." },
    items: [
      { t: { es: "Experiencias únicas", en: "Unique experiences" }, d: { es: "Lugares y actividades que van más allá del turismo tradicional.", en: "Places and activities beyond traditional tourism." } },
      { t: { es: "Atención personalizada", en: "Personal attention" }, d: { es: "Acompañamiento antes, durante y después de tu experiencia.", en: "Support before, during and after your experience." } },
      { t: { es: "Guías locales", en: "Local guides" }, d: { es: "México desde la perspectiva de quienes realmente lo viven.", en: "Mexico from the perspective of those who truly live it." } },
      { t: { es: "Reserva segura", en: "Safe booking" }, d: { es: "Proceso de reserva sencillo, claro y confiable.", en: "Simple, clear and trustworthy booking process." } },
    ],
  },
  tours: {
    kicker: { es: "Tours & experiencias", en: "Tours & experiences" },
    title: { es: "Tours & experiencias curadas.", en: "Curated tours & experiences." },
    sub: { es: "Cinco paquetes para vivir el amanecer sobre Teotihuacán desde un globo: del esencial a la celebración de cumpleaños.", en: "Five packages to live the sunrise over Teotihuacán from a balloon: from the essential to the birthday celebration." },
    see: { es: "Ver experiencia", en: "See experience" },
    from: { es: "Desde", en: "From" },
    consult: { es: "Consultar", en: "On request" },
    all: { es: "Ver todos los tours", en: "See all tours" },
  },
  editorial: {
    kicker: { es: "Selección del curador", en: "Curator's selection" },
    title_a: { es: "Experiencias que", en: "Experiences" },
    title_b: { es: "vale la pena vivir.", en: "worth living." },
    body: {
      es: "Tres maneras de celebrar el amanecer: el desayuno dentro de una cueva volcánica, el recorrido guiado por la Ciudad de los Dioses, un cumpleaños con champagne a 300 metros de altura.",
      en: "Three ways to celebrate the sunrise: breakfast inside a volcanic cave, a guided walk through the City of the Gods, a birthday with champagne 300 meters up.",
    },
  },
  gallery: {
    body: {
      es: "Fotos reales de nuestros viajeros: el amanecer en Teotihuacán, el rugido del quemador y las sonrisas antes y después de volar.",
      en: "Real photos of our travelers: sunrise over Teotihuacán, the roar of the burner and the smiles before and after the flight.",
    },
    video_title: { es: "Así se vive un vuelo con Huitzil-Coatl", en: "This is what a Huitzil-Coatl flight feels like" },
    video_soon: { es: "Video de presentación · próximamente", en: "Intro video · coming soon" },
  },
  teo: {
    kicker: { es: "Destino principal", en: "Main destination" },
    title: { es: "Teotihuacán, más allá de las pirámides.", en: "Teotihuacán, beyond the pyramids." },
    body: {
      es: "Descubre uno de los sitios arqueológicos más fascinantes de México desde una perspectiva diferente.",
      en: "Discover one of Mexico's most fascinating archaeological sites from a different perspective.",
    },
    modes: [
      { t: { es: "Explora", en: "Explore" }, d: { es: "Camina la Calzada de los Muertos a tu ritmo, con quien la conoce de memoria.", en: "Walk the Avenue of the Dead at your pace, with someone who knows it by heart." } },
      { t: { es: "Descubre", en: "Discover" }, d: { es: "La historia y los rituales que aún respiran detrás de cada piedra.", en: "The history and rituals still breathing behind every stone." } },
      { t: { es: "Saborea", en: "Savor" }, d: { es: "Cocina de barro, nopal y pulque: los sabores del valle de Teotihuacán.", en: "Clay-pot cooking, nopal and pulque: the flavors of the Teotihuacán valley." } },
      { t: { es: "Vuela", en: "Fly" }, d: { es: "El amanecer sobre la Pirámide del Sol, visto desde un globo aerostático.", en: "Sunrise over the Pyramid of the Sun, seen from a hot air balloon." } },
    ],
    cta: { es: "Explorar Teotihuacán", en: "Explore Teotihuacán" },
  },
  testimonials: {
    kicker: { es: "Reseñas", en: "Reviews" },
    title: { es: "Viajeros que ya lo vivieron.", en: "Travelers who already lived it." },
    reviews: { es: "reseñas", en: "reviews" },
  },
  about: {
    kicker: { es: "Nuestra historia", en: "Our story" },
    title: { es: "México se vive. Nosotros te llevamos.", en: "Mexico is lived. We take you there." },
    body: {
      es: "Somos una boutique de experiencias mexicanas que nació con una obsesión: que cada viajero se lleve una versión de México que solo puede vivirse. No vendemos tours: acompañamos momentos.",
      en: "We are a boutique of Mexican experiences born from one obsession: that every traveler takes home a version of Mexico that can only be lived. We don't sell tours: we walk alongside moments.",
    },
    p2: {
      es: "Trabajamos con guías locales, cocineros, arqueólogos y pilotos que aman este país tanto como nosotros. Todo lo que ofrecemos lo hemos vivido primero.",
      en: "We work with local guides, cooks, archaeologists and pilots who love this country as much as we do. Everything we offer we have lived first.",
    },
  },
  contact: {
    kicker: { es: "Contacto", en: "Contact" },
    title: { es: "Quiero planear mi experiencia", en: "I want to plan my experience" },
    name: { es: "Nombre", en: "Name" },
    email: { es: "Email", en: "Email" },
    whatsapp: { es: "WhatsApp", en: "WhatsApp" },
    tour_interest: { es: "Tour de interés", en: "Tour of interest" },
    date: { es: "Fecha tentativa", en: "Tentative date" },
    message: { es: "Mensaje", en: "Message" },
    cta: { es: "Quiero planear mi experiencia", en: "I want to plan my experience" },
    thanks: { es: "Gracias, te contactaremos muy pronto.", en: "Thank you, we'll reach out soon." },
  },
  booking: {
    title: { es: "Reserva tu experiencia", en: "Book your experience" },
    step: { es: "Paso", en: "Step" },
    of: { es: "de", en: "of" },
    select_tour: { es: "Selecciona un tour", en: "Select a tour" },
    date: { es: "Fecha", en: "Date" },
    schedule: { es: "Horario", en: "Schedule" },
    adults: { es: "Adultos", en: "Adults" },
    children: { es: "Niños", en: "Children" },
    name: { es: "Nombre completo", en: "Full name" },
    email: { es: "Email", en: "Email" },
    whatsapp: { es: "WhatsApp", en: "WhatsApp" },
    comments: { es: "Comentarios especiales", en: "Special comments" },
    summary: { es: "Resumen de tu reserva", en: "Booking summary" },
    confirm: { es: "Confirmar reserva", en: "Confirm booking" },
    wa_confirm: { es: "Reservar por WhatsApp", en: "Book via WhatsApp" },
    pay_now: { es: "Pagar ahora con tarjeta", en: "Pay now by card" },
    pay_hint: { es: "Pago seguro procesado por Stripe.", en: "Secure payment powered by Stripe." },
    pay_success_title: { es: "¡Pago recibido!", en: "Payment received!" },
    pay_success_msg: { es: "Tu pago se procesó correctamente. Te contactaremos por WhatsApp para coordinar los detalles de tu experiencia.", en: "Your payment was processed successfully. We'll contact you on WhatsApp to coordinate the details of your experience." },
    pay_checking: { es: "Confirmando tu pago…", en: "Confirming your payment…" },
    pay_error: { es: "No pudimos confirmar el pago. Si el cargo aparece en tu tarjeta, contáctanos por WhatsApp.", en: "We couldn't confirm the payment. If the charge appears on your card, contact us on WhatsApp." },
    pay_cancel_title: { es: "Pago cancelado", en: "Payment cancelled" },
    pay_cancel_msg: { es: "No se realizó ningún cargo. Tu reserva sigue guardada: puedes pagar después o confirmar por WhatsApp.", en: "No charge was made. Your booking is still saved: you can pay later or confirm via WhatsApp." },
    next: { es: "Siguiente", en: "Next" },
    back: { es: "Atrás", en: "Back" },
    success_title: { es: "¡Reserva recibida!", en: "Booking received!" },
    success_msg: { es: "Un asesor te contactará muy pronto para confirmar todos los detalles.", en: "An advisor will contact you shortly to confirm all details." },
    total: { es: "Total estimado", en: "Estimated total" },
    price: { es: "Precio", en: "Price" },
    extras_title: { es: "Extras para tu vuelo", en: "Flight extras" },
    extras_hint: { es: "Llévate un recuerdo profesional de tu experiencia.", en: "Take home a professional keepsake of your experience." },
    extra_drone: { es: "Video con drone", en: "Drone video" },
    extra_photos: { es: "Paquete fotográfico", en: "Photo package" },
    extras_bundle_note: { es: "Llévate ambos por MX$2,500 (ahorra MX$500)", en: "Get both for MX$2,500 (save MX$500)" },
    extras_bundle_applied: { es: "Precio combo aplicado", en: "Bundle price applied" },
    extras_label: { es: "Extras", en: "Extras" },
  },
  extras_promo: {
    eyebrow: { es: "Extras exclusivos", en: "Exclusive extras" },
    title: { es: "Haz tu vuelo inolvidable", en: "Make your flight unforgettable" },
    drone: { es: "Video con drone", en: "Drone video" },
    drone_d: { es: "Tu vuelo grabado desde el aire por un piloto profesional. Video editado, listo para compartir.", en: "Your flight filmed from the air by a professional pilot. Edited video, ready to share." },
    photos: { es: "Paquete fotográfico", en: "Photo package" },
    photos_d: { es: "Fotografías profesionales de tu experiencia: desde el despegue hasta el brindis al aterrizar.", en: "Professional photos of your experience: from liftoff to the landing toast." },
    bundle: { es: "Llévate ambos por MX$2,500 y ahorra MX$500", en: "Get both for MX$2,500 and save MX$500" },
    cta: { es: "Agrégalos al reservar", en: "Add them when booking" },
  },
  common: {
    duration: { es: "Duración", en: "Duration" },
    location: { es: "Ubicación", en: "Location" },
    includes: { es: "Qué incluye", en: "What's included" },
    excludes: { es: "No incluye", en: "Not included" },
    itinerary: { es: "Itinerario", en: "Itinerary" },
    meeting: { es: "Punto de encuentro", en: "Meeting point" },
    recs: { es: "Recomendaciones", en: "Recommendations" },
    reviews: { es: "Opiniones", en: "Reviews" },
    book_this: { es: "Reservar esta experiencia", en: "Book this experience" },
    book_wa: { es: "Reservar por WhatsApp", en: "Book via WhatsApp" },
    per_person: { es: "por persona", en: "per person" },
    expert_q: { es: "¿Tienes dudas?", en: "Questions?" },
    expert_sub: { es: "Habla con un experto por WhatsApp", en: "Talk to an expert on WhatsApp" },
    expert_cta: { es: "Hablar por WhatsApp", en: "Chat on WhatsApp" },
  },
  footer: {
    tag: { es: "Experiencias que conectan contigo y con México.", en: "Experiences that connect you with yourself and with Mexico." },
    links: { es: "Enlaces", en: "Links" },
    legal: { es: "Legal", en: "Legal" },
    terms: { es: "Términos y condiciones", en: "Terms & conditions" },
    privacy: { es: "Política de privacidad", en: "Privacy policy" },
    follow: { es: "Síguenos", en: "Follow us" },
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved." },
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("hc_lang") || "es";
  });
  useEffect(() => {
    localStorage.setItem("hc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let node = dict;
    for (const p of parts) node = node?.[p];
    if (node && typeof node === "object" && (node.es || node.en)) return node[lang] || node.es;
    return node;
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const localized = (obj, lang) => (obj?.[lang] ?? obj?.es ?? "");
